module.exports = __webpack_public_path__ + "img/logomarcadark.5087756e.png";